<template>
  <Button
    class="remove-question"
    type="button"
    :label="label"
    @click="toggle($event)"
    aria-haspopup="true"
    aria-controls="overlay_tmenu"
  />
  <TieredMenu
    class="tiered-menu-question"
    id="overlay_tmenu"
    ref="menu"
    :model="items"
    :popup="true"
  />
</template>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: ["items", "label"]
})
export default class SettingsQuestion extends Vue {
  items!: any;
  label!: any;
  public toggle(event: any) {
    const ref = this.$refs as any;
    ref.menu.toggle(event);
  }
}
</script>
